/**
 * StatCard — HomeHub HeroStatChip + DashboardPage StatNumber pattern'ının
 * Mini App'te tek bir kompakt kutu olarak adaptasyonu.
 *
 * Kullanım: 3'lü grid (streak / today / SRS due) — Hub home'da kart altında.
 * Tüm renkler semantic token (bgSecondary/borderPrimary/textPrimary/textMuted).
 */
import { Box, HStack, Text, VStack } from '@chakra-ui/react';

export interface StatCardProps {
  label: string;
  value: string | number;
  glyph?: string;
  /** Glyph rengi (Chakra token). */
  accent?: string;
  /** Ek satır (örn. "SRS bekleyen"). */
  helper?: string;
}

export default function StatCard({ label, value, glyph, accent = 'accent', helper }: StatCardProps) {
  return (
    <Box
      bg="bgSecondary"
      borderWidth="1px"
      borderColor="borderPrimary"
      borderRadius="lg"
      px={3}
      py={2.5}
      minW={0}
    >
      <HStack spacing={2} align="center" mb={1}>
        {glyph ? (
          <Text fontSize="md" lineHeight="1" color={accent} fontWeight="bold">
            {glyph}
          </Text>
        ) : null}
        <Text
          fontSize="10px"
          color="textMuted"
          fontWeight="semibold"
          textTransform="uppercase"
          letterSpacing="0.05em"
          noOfLines={1}
        >
          {label}
        </Text>
      </HStack>
      <VStack align="start" spacing={0.5}>
        <Text fontWeight="bold" fontSize="lg" lineHeight="1.1" color="textPrimary" noOfLines={1}>
          {value}
        </Text>
        {helper ? (
          <Text fontSize="10px" color="textSecondary" noOfLines={1}>
            {helper}
          </Text>
        ) : null}
      </VStack>
    </Box>
  );
}
